import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { UserStatus } from 'api/models';
import { fullName } from 'utils/full-name';
import { CellRendererParams } from './types';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-05);
`;

const DeactivatedText = styled.span`
  color: var(--red-60);
`;
const InvitedText = styled.span`
  color: var(--blue-60);
`;

export const NameRenderer: FC<CellRendererParams> = ({ data }) => {
  const name = fullName(data);

  return (
    <Wrapper>
      <div>
        {name === '' ? data.emailId : name}
        <br />
        {data.userStatus === UserStatus.Inactive && (
          <DeactivatedText>
            <FormattedMessage id="deactivated" />
          </DeactivatedText>
        )}
        {data.userStatus === UserStatus.Invited && (
          <InvitedText>
            <FormattedMessage id="invited" />
          </InvitedText>
        )}
      </div>
    </Wrapper>
  );
};
